module.exports = __webpack_public_path__ + "img/project.2a906c9e.png";